"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isISurveyBuilderQuestion = exports.isDynamicFormAnswer = exports.isTextAnswer = exports.isRatingAnswer = exports.isBooleanChoiceAnswer = exports.isMultipleChoiceAnswer = exports.isSingleChoiceAnswer = exports.isDynamicFormQuestion = exports.isTextQuestion = exports.isRatingQuestion = exports.isBooleanChoiceQuestion = exports.isMultipleChoiceQuestion = exports.isSingleChoiceQuestion = void 0;
var isSingleChoiceQuestion = function (question) {
    return question.type == "surveySingleChoice";
};
exports.isSingleChoiceQuestion = isSingleChoiceQuestion;
var isMultipleChoiceQuestion = function (question) {
    return question.type == "surveyMultipleChoice";
};
exports.isMultipleChoiceQuestion = isMultipleChoiceQuestion;
var isBooleanChoiceQuestion = function (question) {
    return question.type == "surveyBooleanChoice";
};
exports.isBooleanChoiceQuestion = isBooleanChoiceQuestion;
var isRatingQuestion = function (question) {
    return question.type == "surveyRating";
};
exports.isRatingQuestion = isRatingQuestion;
var isTextQuestion = function (question) {
    return question.type == "surveyText";
};
exports.isTextQuestion = isTextQuestion;
var isDynamicFormQuestion = function (question) {
    return question.type == "surveyDynamicForm";
};
exports.isDynamicFormQuestion = isDynamicFormQuestion;
var isSingleChoiceAnswer = function (question) {
    return question.questionType == "surveySingleChoice";
};
exports.isSingleChoiceAnswer = isSingleChoiceAnswer;
var isMultipleChoiceAnswer = function (question) {
    return question.questionType == "surveyMultipleChoice";
};
exports.isMultipleChoiceAnswer = isMultipleChoiceAnswer;
var isBooleanChoiceAnswer = function (question) {
    return question.questionType == "surveyBooleanChoice";
};
exports.isBooleanChoiceAnswer = isBooleanChoiceAnswer;
var isRatingAnswer = function (question) {
    return question.questionType == "surveyRating";
};
exports.isRatingAnswer = isRatingAnswer;
var isTextAnswer = function (question) {
    return question.questionType == "surveyText";
};
exports.isTextAnswer = isTextAnswer;
var isDynamicFormAnswer = function (question) {
    return question.questionType == "surveyDynamicForm";
};
exports.isDynamicFormAnswer = isDynamicFormAnswer;
var isISurveyBuilderQuestion = function (e) {
    return !!(e === null || e === void 0 ? void 0 : e.dragId);
};
exports.isISurveyBuilderQuestion = isISurveyBuilderQuestion;
